import { useId } from 'react';
import { Input } from '@/components/ui/input';
import { categoriesFor } from '@/lib/documentCategories.mjs';

export default function DocumentCategoryInput({ value, onChange, documents = [], disabled = false }) {
  const id = useId();
  return <>
    <Input list={id} value={value || ''} disabled={disabled} maxLength={80}
      placeholder="Choisir ou saisir un thème — vide : Non classés" onChange={(e) => onChange(e.target.value)} />
    <datalist id={id}>{categoriesFor(documents).map((c) => <option key={c} value={c} />)}</datalist>
  </>;
}
